export default "__VITE_ASSET__zjBJADO5__"